import { Component } from '@angular/core';
import { ImageModule } from 'primeng/image';


@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    ImageModule
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

}
